import { motion, AnimatePresence } from "framer-motion";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Navbar } from "react-bootstrap";
import "./menuMobile.css";
import { useAuth } from "../../../context/AuthContext.jsx";

export default function MenuMobile() {
  const [isOpen, setIsOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const toggleMenu = () => setIsOpen(prev => !prev);
  const location = useLocation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    setIsOpen(false);
    navigate("/welcome");
  };

  return (
    <>
      <Navbar.Toggle
        aria-controls="menu-overlay"
        className={`d-lg-none custom-toggle ${isOpen ? "open" : ""}`}
        onClick={toggleMenu}
      >
        <span></span>
      </Navbar.Toggle>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="menu-overlay"
            id="menu-overlay"
            initial={{ opacity: 0, x: "100%" }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: "100%" }}
            transition={{ duration: 0.3 }}
          >
            <nav className="menu-content">
              <Link
                to="/welcome"
                onClick={toggleMenu}
                className={location.pathname === "/welcome" ? "active" : ""}
              >
                INÍCIO
              </Link>
              <Link
                to="/perdidos"
                onClick={toggleMenu}
                className={location.pathname === "/perdidos" ? "active" : ""}
              >
                PERDIDOS
              </Link>
              <Link
                to="/ouropreto"
                onClick={toggleMenu}
                className={location.pathname === "/ouropreto" ? "active" : ""}
              >
                OURO PRETO
              </Link>
              <Link
                to="/contact"
                onClick={toggleMenu}
                className={location.pathname === "/contact" ? "active" : ""}
              >
                CONTATO
              </Link>
              {!user ? (
                <Link to="/login" onClick={toggleMenu} className="menu-login-btn">
                  <i className="bi bi-person"></i> Login
                </Link>
              ) : (
                <div className="menu-user-dropdown">
                  <button
                    className="menu-user-name"
                    onClick={() => setUserMenuOpen((open) => !open)}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#1A9EE0",
                      fontSize: "1.7rem",
                      fontWeight: 500,
                      display: "flex",
                      alignItems: "center",
                      gap: "0.8rem",
                    }}
                  >
                    <i className="bi bi-person-circle"></i> {user?.nickname || "Usuário"}
                  </button>
                  {userMenuOpen && (
                    <div className="menu-user-submenu">
                      <Link
                        to="/home"
                        onClick={() => { toggleMenu(); setUserMenuOpen(false); }}
                        className="menu-user-link"
                        style={{
                          fontSize: "1.3rem",
                          fontWeight: 500,
                          display: "flex",
                          alignItems: "center",
                          gap: "0.8rem",
                        }}
                      >
                        <i className="bi bi-house-door"></i> Portal
                      </Link>
                      <button
                        onClick={() => { handleLogout(); setUserMenuOpen(false); }}
                        className="menu-user-logout"
                        type="button"
                        style={{
                          fontSize: "1.3rem",
                          fontWeight: 500,
                          display: "flex",
                          alignItems: "center",
                          gap: "0.8rem",
                        }}
                      >
                        <i className="bi bi-box-arrow-right"></i> Sair
                      </button>
                    </div>
                  )}
                </div>
              )}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}